import ApiRoot from '@http/ApiRoot';

export default async function () {
  try {
    let inventory;
    if (window.inventoryLoading instanceof Promise) {
      inventory = await window.inventoryLoading;
    }

    if (!inventory) {
      window.inventoryLoading = new Promise((resolve, reject) => {
        window.inventoryLoadingResolve = resolve;
        window.inventoryLoadingReject = reject;
      });

      inventory = await ApiRoot.get('/inventory', {
        cache: {
          maxAge: 30000 // 30s
        }
      });

      window.inventoryLoadingResolve(inventory);
      window.inventoryLoading = null;
    }

    return inventory;
  } catch (error) {
    console.error('getInventory', error)
    return new Error(error)
  }
}
